/** Scrolls only the canvas' own scroll container (never the window) so the shell and chat stay put. */
export function scrollIntoCanvas(el, { block = "start", offset = 96, behavior = "smooth" } = {}) {
  if (!el) return;
  const root = el.closest('[data-testid="project-canvas-scroll"]');
  if (!root) { el.scrollIntoView({ behavior, block }); return; }
  const r = el.getBoundingClientRect();
  const rr = root.getBoundingClientRect();
  const rel = r.top - rr.top + root.scrollTop;
  const top = block === "center" ? rel - (rr.height - r.height) / 2 : rel - offset;
  root.scrollTo({ top: Math.max(0, top), behavior });
}
